/* ─────────────────────────────────────────────────────────────────────────
   Water Level page — reuses the EXISTING DashboadSensorBoxV2 card verbatim.
   Only adds a page header + sort/filter chips. Cards self-fetch their data.
   ──────────────────────────────────────────────────────────────────────── */
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { BiWater } from "react-icons/bi";
import DashboadSensorBoxV2 from "../sensor/DashboadSensorBoxV2";
import SplashScreen from "../utils/SplashScreen";
import { useSensorList, useWaterStates } from "./dashV3.data";
import {
  PageContainer, ContentContainer, OuterBox, SensorType, DeviceGroup,
  PageHeader, BackBtn, HeaderTitle, HeaderCount, ChipRow, Chip, Msg,
} from "./dashV3.styles";

const SEVERITY = { offline: 0, faulty: 1, overflow: 2, low: 3 };
const sev = (kind) => (kind in SEVERITY ? SEVERITY[kind] : 4);

const SORTS = [
  { id: "attention", label: "Needs attention" },
  { id: "all",       label: "All" },
  { id: "low",       label: "Low → High %" },
  { id: "az",        label: "A–Z" },
];

export default function WaterLevelPageV3() {
  const history = useHistory();
  const { loading, water } = useSensorList();
  const stateMap = useWaterStates(water, !loading && water.length > 0);
  const [sort, setSort] = useState("attention");

  const ordered = useMemo(() => {
    const list = [...water];
    const st = (s) => stateMap[s.sensor_id] || {};
    if (sort === "attention") {
      list.sort((a, b) => sev(st(a).kind) - sev(st(b).kind));
    } else if (sort === "low") {
      list.sort((a, b) => (st(a).level ?? 999) - (st(b).level ?? 999));
    } else if (sort === "az") {
      list.sort((a, b) => (st(a).name || a.name || "").localeCompare(st(b).name || b.name || ""));
    }
    return list;
  }, [water, stateMap, sort]);

  if (loading) return <SplashScreen />;

  return (
    <PageContainer>
      <PageHeader>
        <BackBtn onClick={() => history.push("/")}>←</BackBtn>
        <BiWater size={20} color="#237A35" />
        <HeaderTitle>Water Level</HeaderTitle>
        <HeaderCount>{water.length} tanks</HeaderCount>
      </PageHeader>

      <ChipRow>
        {SORTS.map((s) => (
          <Chip key={s.id} $active={sort === s.id} onClick={() => setSort(s.id)}>{s.label}</Chip>
        ))}
      </ChipRow>

      <ContentContainer>
        <OuterBox>
          <SensorType>Water Level</SensorType>
          {ordered.length === 0 ? (
            <Msg>No water-level sensors.</Msg>
          ) : (
            <DeviceGroup>
              {ordered.map((s) => (
                <DashboadSensorBoxV2 key={s.sensor_id} sensor_id={s.sensor_id} type={s.type} />
              ))}
            </DeviceGroup>
          )}
        </OuterBox>
      </ContentContainer>
    </PageContainer>
  );
}
